export class DiscountType {
  static get WarrantyPeriod () {
    return 1
  }
  static get Money () {
    return 2
  }
  static get Percent () {
    return 3
  }
  static get Prepayment () {
    return 4
  }
  static get Day () {
    return 5
  }
  static get Deposit () {
    return 6
  }

  static DiscountTypeName (DiscountType) {
    let tmpType = parseInt(DiscountType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '期數'
        break
      case 2:
        name = '金額'
        break
      case 3:
        name = '%數'
        break
      case 4:
        name = '預繳'
        break
      case 5:
        name = '天數'
        break
      case 6:
        name = '訂金'
        break
    }
    return name
  }
}
